import { IconName } from '@fashionnovateam/nova-ui-toolkit';
import roles from '../../Lib/Constants/roles';

export type ContactFlowOption = {
  nextStep: string;
  label: string;
  description?: string;
  isFinal?: boolean;
  icon: IconName;
};

export type ContactFlowStep = {
  id: string;
  title?: string;
  options?: ContactFlowOption[];
};

export const getContactFlowData = (userRole: string): ContactFlowStep[] => {
  if (userRole === roles.INFLUENCER) {
    return [
      {
        id: 'contactType',
        options: [
          {
            nextStep: 'account',
            label: 'Account',
            description:
              'Issues logging in, password resets, access codes or 2FA.',
            isFinal: true,
            icon: 'user/user-user-01',
          },
          {
            nextStep: 'generalQuestion',
            label: 'General Question or Help',
            description: 'Get help with any questions or issues you have.',
            isFinal: true,
            icon: 'question/question-mark-circle',
          },
        ],
      },
      {
        id: 'finalStep',
        title: 'Provide Details',
      },
    ];
  }
  return [
    {
      id: 'contactType',
      options: [
        {
          nextStep: 'payments',
          label: 'Payments',
          description: 'Payment details, billing, invoices and chargebacks.',
          icon: 'credit-card/credit-card-locked',
        },
        {
          nextStep: 'purchaseOrders',
          label: 'Purchase Orders',
          description:
            'Revisions, scheduling, deliveries, receiving or compliance.',
          icon: 'package/package-02',
        },
      ],
    },
    {
      id: 'payments',
      title: 'Payment Issue',
      options: [
        {
          nextStep: 'updatePaymentDetails',
          label: 'Update Payment Details',
          description: 'Update your banking details for receiving payments.',
          isFinal: true,
          icon: 'lock/lock-close',
        },
        {
          nextStep: 'billingOrInvoices',
          label: 'Billing or Invoices',
          description: 'For any questions regarding payments.',
          isFinal: true,
          icon: 'file/file-text',
        },
        {
          nextStep: 'chargebacks',
          label: 'Chargebacks',
          description: 'Discuss or dispute chargebacks on your account.',
          isFinal: true,
          icon: 'balance-scale-law',
        },
      ],
    },
    {
      id: 'purchaseOrders',
      title: 'Purchase Order Issue',
      options: [
        {
          nextStep: 'receiving',
          label: 'Receiving',
          description:
            'Reach the team at our warehouses and distribution centre.',
          isFinal: true,
          icon: 'lock/lock-close',
        },
        {
          nextStep: 'schedulingDeliveries',
          label: 'Scheduling & Deliveries',
          description: 'For any questions regarding payments.',
          isFinal: true,
          icon: 'file/file-text',
        },
        {
          nextStep: 'revisions',
          label: 'Revisions',
          description: 'All PO changes not related to scheduling and delivery.',
          isFinal: true,
          icon: 'pencil-edit/pencil-edit-line',
        },
        {
          nextStep: 'compliance',
          label: 'Compliance',
          description: 'Certificate of insurance, audits, Prop65 and more.',
          isFinal: true,
          icon: 'balance-scale-law',
        },
      ],
    },
    {
      id: 'finalStep',
      title: 'Provide Details',
    },
  ];
};
